import { FloorplanKvmReceiver } from "@domain/project/floorplan/monitoring/floorplan-kvm-receiver";
import { FloorplanWorkspaceKonvaAdapter } from "@project/floorplanner/konva/floorplan-workspace-konva.adapter";
import { IconKonva } from "@project/floorplanner/konva/icon-konva";
import { RemoteSensorWireKonva } from "@project/floorplanner/konva/remote-sensor-wire-konva";
import Konva from "konva";

export interface KvmReceiverKonvaShapes {
  group: Konva.Group;
  receiver: Konva.Image;
}

export class KvmReceiverKonva {
  static init(receiver: FloorplanKvmReceiver, receiverIcon: Konva.Image, transmitterIcon: Konva.Image): KvmReceiverKonvaShapes {
    const receiverGroup = new Konva.Group({ id: receiver.id });
    receiverGroup.setAttr(FloorplanWorkspaceKonvaAdapter.OBJECT_KEY, receiver);

    const iconGroup = IconKonva.initIconGroup(receiver);
    IconKonva.initIconAttrs(receiverIcon, receiver, 0, 0);
    IconKonva.initTransformEndHandler(receiverIcon, receiver);
    iconGroup.add(receiverIcon);
    receiverGroup.add(iconGroup);

    const wire = RemoteSensorWireKonva.init(transmitterIcon, receiverIcon);
    receiverGroup.add(wire);

    receiverIcon.on("dragmove", () => RemoteSensorWireKonva.updateWire(wire, transmitterIcon, receiverIcon));
    receiverIcon.on("transform", () => RemoteSensorWireKonva.updateWire(wire, transmitterIcon, receiverIcon));

    return { group: receiverGroup, receiver: receiverIcon };
  }

  static getWire(receiverGroup: Konva.Group): Konva.Line {
    return receiverGroup.getChildren()[1] as Konva.Line;
  }
}
